import { render, staticRenderFns } from "./list.vue?vue&type=template&id=76b733da&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=76b733da&prod&scoped=true&lang=less"
import style1 from "./list.vue?vue&type=style&index=1&id=76b733da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b733da",
  null
  
)

export default component.exports